// Mock API for demonstration purposes
// Saves to localStorage and provides success responses

export const mockApi = {
  // Mock endpoint for lead submissions
  submitLead: async (leadData) => {
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Get existing leads from localStorage
      const existingLeads = JSON.parse(localStorage.getItem('leads') || '[]');
      
      // Add new lead with timestamp and ID
      const newLead = {
        id: Date.now().toString(),
        ...leadData,
        timestamp: new Date().toISOString(),
        status: 'new'
      };
      
      // Save to localStorage
      const updatedLeads = [...existingLeads, newLead];
      localStorage.setItem('leads', JSON.stringify(updatedLeads));
      
      // Console log for demo purposes
      console.log('📝 New Lead Submitted:', newLead);
      
      return {
        ok: true,
        success: true,
        message: "Thank you for your inquiry! We'll contact you within 24 hours.",
        data: { leadId: newLead.id }
      };
    } catch (error) {
      console.error('Mock API Error:', error);
      return {
        ok: false,
        success: false,
        message: "There was an error submitting your request. Please try again.",
        error: error.message
      };
    }
  },

  // Get all leads (for admin page)
  getLeads: () => {
    try {
      const leads = JSON.parse(localStorage.getItem('leads') || '[]');
      return {
        ok: true,
        success: true,
        data: leads.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
      };
    } catch (error) {
      return {
        ok: false,
        success: false,
        message: "Error fetching leads",
        error: error.message
      };
    }
  },

  // Clear all leads (for demo purposes)
  clearLeads: () => {
    try {
      localStorage.removeItem('leads');
      return {
        ok: true,
        success: true,
        message: "All leads cleared successfully"
      };
    } catch (error) {
      return {
        ok: false,
        success: false,
        message: "Error clearing leads",
        error: error.message
      };
    }
  }
};

// Email intent mapping
export const emailIntents = {
  'pricing': 'sales@automats.com',
  'quote': 'sales@automats.com', 
  'sales': 'sales@automats.com',
  'sample': 'samples@automats.com',
  'samples': 'samples@automats.com',
  'support': 'support@automats.com',
  'msds': 'support@automats.com',
  'replacement': 'support@automats.com',
  'partnership': 'partnerships@automats.com',
  'branding': 'partnerships@automats.com',
  'custom': 'partnerships@automats.com',
  'general': 'sales@automats.com'
};